import { render, staticRenderFns } from "./SwiperMultiRowSlides.vue?vue&type=template&id=9f8bd9e0&scoped=true"
import script from "./SwiperMultiRowSlides.vue?vue&type=script&lang=js"
export * from "./SwiperMultiRowSlides.vue?vue&type=script&lang=js"
import style0 from "./SwiperMultiRowSlides.vue?vue&type=style&index=0&id=9f8bd9e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8bd9e0",
  null
  
)

export default component.exports